
var lastInput = null
var inputValue = null
// {{{ fIsInput
const fIsInput = function (type) {
	return type === 'text' || type === 'search' || type === 'password' ||
		type === 'textarea' || type === 'number'
}
// }}}
// {{{ fFixScroller
const fFixScroller = function (e) {
	if (fIsInput(e.target.type)) {
		lastInput = null
		window.setTimeout(() => {
			if (lastInput === null) {
				window.scrollTo(0, 0)
			}
		})
	}
}
// }}}
// {{{ fSaveLastInput
const fSaveLastInput = function (e) {
	var target = e.target
	if (fIsInput(target.type)) {
		lastInput = target
	}
}
// }}}
const fIsClearable = function (e) {
	var target = e.target
	return target.type === 'number' && (target.value === null || target.value === '')
}
// fInputGetFocus 获取焦点时，清空input框的值
const fInputGetFocus = function (e) {
	var target = e.target
	if (target.type === 'button' || target.getAttribute('readonly') || !fIsClearable(e)) {
		return
	}
	if (target.type === 'number' && (target.value === null || target.value === '')) {
		inputValue = target.value
		target.value = null
	}
}
// fInputLoseFocus 失去焦点且input框为空时，将之前的值重新赋到input框
const fInputLoseFocus = function (e) {
	var target = e.target
	if (target.getAttribute('readonly') || !fIsClearable(e)) {
		return
	}
	target.value = inputValue
}

export default {
	// {{{ fixKeyboard
	fixKeyboard () {
		var body = document.body
		body.addEventListener('blur', fFixScroller, true)
		body.addEventListener('focus', fSaveLastInput, true)
	},
	// }}}
	fixInputboard () {
		var body = document.body
		body.addEventListener('blur', fInputLoseFocus, true)
		body.addEventListener('focus', fInputGetFocus, true)
	}
}



// WEBPACK FOOTER //
// ./src/lib/czqui/util/KeyboardUtils.js